/**
 * Gyro Tank — Wind master. Japanese Koma (spinning tops) that ride the breeze.
 * Shot 1: Skipper — bouncing Koma with skip explosions.
 * Shot 2: Drill Mine — rises, drills a wide shaft, detonates at the bottom.
 */

import { registerTank } from './registry';
import { GYRO_SHOT1, GYRO_SHOT2 } from './gyro/spin';

// ─── Tank Registration ───────────────────────────────────────────────────────

registerTank({
  id: 'gyro',
  name: 'Gyro',
  description: 'Wind master. Spinning tops that ride the breeze.',
  disabled: false,
  bonus: true,
  chargeSize: 85,
  visual: { bodyColor: 0x6B8F5E, glowColor: 0x88CC77, bodyRadius: 35 },
  ecbRadius: 27,
  landingMultiplier: 1.1,
  shots: [
    { tier: 1, weapon: GYRO_SHOT1, momentumCost: 0, hitlagBonus: 0, label: 'Skipper',    tierColor: 0x88CC77 },
    { tier: 2, weapon: GYRO_SHOT2, momentumCost: 0, hitlagBonus: 0, label: 'Drill Mine', tierColor: 0xFF6644 },
  ],
});
